/**
 * Cart Pubblienne — Optimistic UI v4
 *
 * All qty/price updates happen INSTANTLY on click.
 * Remove buttons instantly hide the row.
 * Dawn syncs with server in background and re-renders the product list.
 */
(function(){
  'use strict';

  /* Quantita desiderata per riga (sopravvive ai re-render, chiave = data-index) */
  var pubDesired = {};
  var pubTimer = {};

  /* ── Money formatting (Italian) ── */
  function fmt(cents){
    var abs = Math.abs(Math.round(cents));
    var eur = Math.floor(abs / 100);
    var ct = String(abs % 100).padStart(2, '0');
    var s = eur.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + ct;
    return (cents < 0 ? '-' : '') + '\u20AC' + s;
  }

  function parse(str){
    if (!str) return 0;
    var c = str.replace(/[^\d.,-]/g, '');
    var p = c.split(',');
    if (p.length === 2) return Math.round(parseFloat(p[0].replace(/\./g, '') + '.' + p[1]) * 100) || 0;
    return Math.round(parseFloat(c.replace(/\./g, '')) * 100) || 0;
  }

  /* ── Recalc all summaries ── */
  function recalc(){
    var tot = 0, cnt = 0;
    document.querySelectorAll('.cart-pub__p-row:not(.cart-pub__p-row--removing)').forEach(function(r){
      var q = r.querySelector('.cart-pub__qty-val');
      var t = r.querySelector('.cart-pub__p-total');
      if (!q || !t) return;
      var qty = parseInt(q.value) || 0;
      cnt += qty;
      // Riga scontata = "<s>pieno</s> finale": somma solo il prezzo FINALE
      // (i text node), ignorando il vecchio prezzo barrato nello <s>.
      var oldS = t.querySelector('.cart-pub__p-total-old');
      if (oldS) {
        var finalStr = '';
        t.childNodes.forEach(function(n){ if (n.nodeType === 3) finalStr += n.textContent; });
        tot += parse(finalStr);
      } else {
        tot += parse(t.textContent);
      }
    });

    var f = fmt(tot);
    var lbl = cnt + ' articol' + (cnt === 1 ? 'o' : 'i');

    set('.cart-pub__sum-line b', f);
    set('.cart-pub__sum-total-value', f + ' EUR');
    set('.cart-pub__sum-head span', lbl);
    set('.cart-pub__eyebrow', 'Il tuo ordine \u00B7 ' + lbl);
    set('.cart-pub__m-tot-value', f);
    set('.cart-pub__m-tot-label', 'Totale \u00B7 ' + lbl);
  }

  function set(sel, txt){
    var el = document.querySelector(sel);
    if (el) el.textContent = txt;
  }

  /* ── Prezzo unitario per scaglione (centesimi) + -20% no personalizzazione ── */
  function tierUnit(tiers, qty, baseCents, noPerso){
    var unit = baseCents;
    if (tiers){
      var type = tiers.type || 'fixed';
      var list = tiers.tiers || tiers;
      if (list && list.length){
        for (var i = 0; i < list.length; i++){
          var t = list[i];
          var mx = (t.max === null || t.max === undefined) ? Infinity : t.max;
          if (qty >= t.min && qty <= mx){
            var val = (t.value != null) ? t.value : t.price;
            unit = (type === 'percent')
              ? Math.round(baseCents * (1 - parseFloat(val) / 100))
              : Math.round(parseFloat(val) * 100);
            break;
          }
        }
      }
    }
    if (noPerso) unit = Math.round(unit * 0.8);
    return unit;
  }

  /* ── Sync UNA volta sola al server (al termine dei click) ──
     Invia la quantita finale, poi re-renderizza items+footer dal server
     in modo controllato. Niente messaggi "You can only add X" da race. ── */
  function syncLine(line){
    var qty = pubDesired[line];
    if (qty == null) return;

    var itemsWrap = document.getElementById('main-cart-items');
    var sectionId = itemsWrap ? itemsWrap.dataset.id : null;
    var body = { line: line, quantity: qty, sections_url: window.location.pathname };
    if (sectionId) body.sections = [sectionId];

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(r){ return r.json(); })
    .then(function(state){
      if (!state || state.status) return;              // errore: lascia stato ottimistico
      if (state.item_count === 0) { location.reload(); return; }
      if (state.sections && sectionId && state.sections[sectionId]) {
        var doc = new DOMParser().parseFromString(state.sections[sectionId], 'text/html');
        var ni = doc.querySelector('.js-contents-items');
        var nf = doc.querySelector('.js-contents-footer');
        var ci = document.querySelector('.js-contents-items');
        var cf = document.querySelector('.js-contents-footer');
        if (ni && ci) ci.innerHTML = ni.innerHTML;
        if (nf && cf) cf.innerHTML = nf.innerHTML;     // footer = totali reali (sconti inclusi)
      }
      // Click avvenuti durante la richiesta: il desiderato e cambiato -> riallinea e ri-sincronizza
      var srvQty = (state.items && state.items[line - 1]) ? state.items[line - 1].quantity : null;
      if (srvQty != null && pubDesired[line] !== srvQty) {
        var ni2 = document.getElementById('Quantity-' + line);
        if (ni2) { ni2.value = pubDesired[line]; }
        recalc();
        syncLine(line);
      } else {
        recalc();
      }
    })
    .catch(function(){});
  }

  /* ── Handle remove button click (capture phase) ── */
  document.addEventListener('click', function(ev){
    var removeBtn = ev.target.closest('.cart-pub__p-remove');
    if (!removeBtn) return;
    var row = removeBtn.closest('.cart-pub__p-row');
    if (!row) return;

    // Instantly hide the row with animation
    row.classList.add('cart-pub__p-row--removing');
    row.style.overflow = 'hidden';
    row.style.transition = 'opacity .25s, max-height .3s .05s';
    row.style.opacity = '0';
    row.style.maxHeight = row.offsetHeight + 'px';
    requestAnimationFrame(function(){
      row.style.maxHeight = '0';
    });

    // Also hide the error row if present
    var errorRow = row.nextElementSibling;
    if (errorRow && errorRow.classList.contains('cart-pub__p-error')) {
      errorRow.style.display = 'none';
    }

    // Annulla TUTTE le sync +/- in coda: dopo la rimozione gli indici riga
    // shiftano, quindi una syncLine ritardata ri-aggiungerebbe/sbaglierebbe riga.
    Object.keys(pubTimer).forEach(function(k){ clearTimeout(pubTimer[k]); });
    pubTimer = {};
    pubDesired = {};

    // Recalc summaries immediately (row excluded via --removing class)
    recalc();

    // Let the event bubble to CartRemoveButton which handles server sync
  }, true);

  /* ── Handle +/- click (capture phase, runs before Dawn) ── */
  document.addEventListener('click', function(ev){
    var btn = ev.target.closest('[name="plus"], [name="minus"]');
    if (!btn) return;
    var row = btn.closest('.cart-pub__p-row');
    if (!row) return;
    var input = row.querySelector('.cart-pub__qty-val');
    if (!input) return;

    var action = btn.name;
    var cur = parseInt(input.value) || 0;
    var step = parseInt(input.step) || 1;
    var mn = parseInt(input.min) || 0;
    var mx = input.max ? parseInt(input.max) : 999999;
    var nxt = action === 'plus' ? Math.min(cur + step, mx) : Math.max(cur - step, mn);

    if (nxt === cur) return;

    // 1. Update input value + memorizza desiderato per riga
    input.value = nxt;
    pubDesired[input.dataset.index] = nxt;

    // 2. Update line total con il prezzo SCAGLIONE corretto per la nuova qty
    var totalEl = row.querySelector('.cart-pub__p-total');
    var unitWrap = row.querySelector('.cart-pub__p-unit');
    var baseCents = parseInt(input.getAttribute('data-base-cents'));
    if (isNaN(baseCents)) {
      var ub = row.querySelector('.cart-pub__p-unit b');
      baseCents = ub ? parse(ub.textContent) : 0;
    }
    var noPerso = input.getAttribute('data-noperso') === 'true';
    var tiers = null;
    var traw = input.getAttribute('data-tiers');
    if (traw) { try { tiers = JSON.parse(traw); } catch(e){ tiers = null; } }

    var unit = tierUnit(tiers, nxt, baseCents, noPerso);
    var lc = unit * nxt;

    if (totalEl){
      if (unit < baseCents){
        totalEl.innerHTML = '<s class="cart-pub__p-total-old">' + fmt(baseCents * nxt) + '</s> ' + fmt(lc);
      } else {
        totalEl.textContent = fmt(lc);
      }
    }
    if (unitWrap){
      if (unit < baseCents){
        unitWrap.innerHTML = '<s class="cart-pub__p-unit-old">' + fmt(baseCents) + '</s> <b>' + fmt(unit) + '</b>';
      } else {
        unitWrap.innerHTML = 'Prezzo unitario · <b>' + fmt(unit) + '</b>';
      }
    }

    // 3. Recalc summaries
    recalc();

    // 4. Prevent Dawn from also stepping (we already changed the value)
    ev.stopImmediatePropagation();
    ev.preventDefault();

    // 5. Sync UNA volta sola dopo l'ultimo click (debounce per riga).
    var ln = input.dataset.index;
    clearTimeout(pubTimer[ln]);
    pubTimer[ln] = setTimeout(function(){ syncLine(ln); }, 500);

  }, true); // capture phase

  /* ── Clamp manuale al minimo custom (prima della sync Dawn) ── */
  document.addEventListener('change', function(ev){
    var input = ev.target;
    if (!input || !input.classList || !input.classList.contains('cart-pub__qty-val')) return;
    var cmin = parseInt(input.getAttribute('data-cmin')) || parseInt(input.min) || 1;
    var val = parseInt(input.value);
    if (isNaN(val) || val < cmin) {
      input.value = cmin;
    }
  }, true); // capture: prima del handler Dawn

})();
